import firebase from 'firebase'
import store from "./store";

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyC6-mEOImDF1S7m31LBuagw_3-HrujBXWY',
  authDomain: 'vue-chat-17a86.firebaseapp.com',
  databaseURL: 'https://vue-chat-17a86.firebaseio.com',
  projectId: 'vue-chat-17a86',
  storageBucket: 'vue-chat-17a86.appspot.com',
  messagingSenderId: '989267710768',
  appId: '1:989267710768:web:3a3b1b010c3f2cce516ef5',
  measurementId: 'G-WXCH0T6SQ8'
}
firebase.initializeApp(config)
firebase.analytics()

export default {
  // init() {
  //   firebase.initializeApp(config);
  //   firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
  // },
  // login() {
  //   const provider = new firebase.auth.TwitterAuthProvider()
  //   firebase.auth().signInWithPopup(provider)
  // },
  // loginAnonymouse(){
  //   firebase.auth().signInAnonymously().catch( (error) => {
  //     console.log(`[error] Can not signin anonymouse (${error.code}:${error.message})`);
  //   });
  // },
  logout() {
    firebase.auth().signOut()
  },
  onAuth() {
    firebase.auth().onAuthStateChanged(user => {
      user = user ? user : {}
      store.commit('onAuthStateChanged', user)
    });
  }
}